// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SaintHelenaAscensionAndTristanDaCunha from '../_raw/flag/icon_flag_saint_helena_ascension_and_tristan_da_cunha.png';

export default () => (
  <img src={SaintHelenaAscensionAndTristanDaCunha} alt="SaintHelenaAscensionAndTristanDaCunha" />
);
